export default "__VITE_ASSET__DpsFfkU8__"